import { BASE_URL_API } from 'constants/base-url-default'
import { getCookie } from 'utils/functions-cookie'

export interface SearchEmployees {
  id: string
  name: string
  email: string
}

export const getSearchEmployees = async (urlParams: string) => {
  const authToken = getCookie('auth_token')

  if (!authToken) {
    throw new Error('Você não está autenticado.')
  }

  const response = await fetch(
    `${BASE_URL_API}/employees/search/${urlParams}`,
    {
      method: 'GET',
      headers: {
        'Access-Control-Allow-Origin': '*',
        'Content-Type': 'application/json',
        Authorization: `Bearer ${authToken}`,
      },
    },
  )

  if (response.status === 401) {
    throw new Error('Sessão expirada')
  }

  const { ...data } = (await response.json()) as SearchEmployees[]

  return data
}
